import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel,
  SidebarMenu, 
  SidebarMenuButton, 
  SidebarMenuItem,
  useSidebar 
} from '@/components/ui/sidebar';
import { Shield, Users, Settings, BarChart3 } from 'lucide-react';
import { useSupabaseAuth } from '@/hooks/auth';
import { useSidebarNavigation } from '@/hooks/useSidebarNavigation';

export const ManagementNavigationSection = () => {
  const { state } = useSidebar();
  const { hasAccess } = useSupabaseAuth();
  const { isActive } = useSidebarNavigation();

  // Only show if user has staff or admin access
  if (!hasAccess('staff') && !hasAccess('admin')) {
    return null;
  }

  const getNavClass = (path: string) => 
    isActive(path) ? "bg-muted text-primary font-medium" : "hover:bg-muted/50";

  // Determine navigation items based on access level
  const getManagementItems = () => {
    const items = [];

    if (hasAccess('staff')) {
      items.push(
        { title: "Staff Dashboard", url: "/staff", icon: BarChart3 }
      );
    }

    if (hasAccess('admin')) {
      items.push(
        { title: "Admin Dashboard", url: "/admin", icon: Shield },
        { title: "System Settings", url: "/admin/settings", icon: Settings }
      );
    }

    // User Management available to both staff and admin
    if (hasAccess('staff') || hasAccess('admin')) {
      const userManagementUrl = hasAccess('admin') ? "/admin/users" : "/staff/users";
      items.push(
        { title: "User Management", url: userManagementUrl, icon: Users }
      );
    }

    return items;
  };

  const managementItems = getManagementItems();

  if (managementItems.length === 0) {
    return null;
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Management</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {managementItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild>
                <NavLink to={item.url} className={getNavClass(item.url)}>
                  <item.icon className="h-4 w-4" />
                  {state !== "collapsed" && <span>{item.title}</span>}
                </NavLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};